import { render } from "./transporteSinSoporte.vue?vue&type=template&id=6806322c"
import script from "./transporteSinSoporte.vue?vue&type=script&lang=js"
export * from "./transporteSinSoporte.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__